import axios from "../../axios";

export const state = {
    dashboardData: {},
    siteSettings: null
}

export const mutations = {
    UPDATE_DASHBOARD_DATA(state, data) {
        state.dashboardData = data
    },
    SET_SITE_SETTINGS(state, data) {
        state.siteSettings = data
    }
}

export const actions = {
    updateDashboardData({commit}, data) {
        commit('UPDATE_DASHBOARD_DATA', data)
    },
    async fetchSiteSettings({commit}) {
        await axios.get('site-settings')
            .then((res) => {
                commit('SET_SITE_SETTINGS', res.data)
            })
    }
}
